// extracted by mini-css-extract-plugin
export default {"h":"styles_h__l3iL5","p":"styles_p__whNfY"};